import { Box } from "@mui/material";
import { NadraIcon, RaastApprovedLogo, TrustShieldIcon } from "../../../assets/icons/icon";
import styles from "./styles.module.css";
import { ParagraphText } from "../../../Libraries";

const FooterRupin = () => {
  return (
    <Box className={`footerRupin ${styles.container}`}>
      {/* <Box className={styles.Box}>
        <RaastApprovedLogo />
        <ParagraphText className={"newLightColor fontSize14"}>Licensed by SBP</ParagraphText>
      </Box>
      <Box className={styles.Box}>
        <NadraIcon />
        <ParagraphText className={"newLightColor fontSize14"}>Powered by Nadra</ParagraphText>
      </Box> */}
      <Box className={styles.Box}>
        <TrustShieldIcon />
        <ParagraphText className={"newLightColor fontSize14"}>Trusted by 5.3 million+ users</ParagraphText>
      </Box>
    </Box>
  );
};
export default FooterRupin;